import { render, staticRenderFns } from "./PersonTypePersistView.vue?vue&type=template&id=67a41f8e"
import script from "./PersonTypePersistView.vue?vue&type=script&lang=ts"
export * from "./PersonTypePersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports